import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "message text-deemphasized" }

import { useRouter } from 'vue-router';


import Card from '@shell/components/Resource/Detail/Card/index.vue';
import { useI18n } from '@shell/composables/useI18n';
import { useStore } from 'vuex';
import { BLANK_CLUSTER } from '@shell/store/store-types';

export default /*@__PURE__*/_defineComponent({
  __name: 'ExtrasCard',
  setup(__props) {

const store = useStore();
const router = useRouter();
const i18n = useI18n(store);

const extensionsUrl = router.resolve({
  name:   'c-cluster-uiplugins',
  params: { cluster: BLANK_CLUSTER }
}).href;

const clusterToolsUrl = router.resolve({
  name:   'c-cluster-apps-charts',
  params: { cluster: BLANK_CLUSTER }
}).href;

return (_ctx: any,_cache: any) => {
  const _directive_clean_html = _resolveDirective("clean-html")!

  return (_openBlock(), _createBlock(Card, {
    title: _unref(i18n).t('component.resource.detail.card.extrasCard.title')
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("p", _hoisted_1, null, 512), [
        [_directive_clean_html, _unref(i18n).t('component.resource.detail.card.extrasCard.message', { extensionsUrl: _unref(extensionsUrl), clusterToolsUrl: _unref(clusterToolsUrl) }, true)]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})